import { render, staticRenderFns } from "./RegistroFatture.vue?vue&type=template&id=8ff66be6"
import script from "./RegistroFatture.vue?vue&type=script&lang=js"
export * from "./RegistroFatture.vue?vue&type=script&lang=js"
import style0 from "./RegistroFatture.vue?vue&type=style&index=0&id=8ff66be6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports